/* Nebula homepage: Klaviyo list signups + sticky mobile buy bar */
(function () {
  function klaviyoSubscribe(companyId, listId, email) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      })
    }).then(function (r) { if (!r.ok && r.status !== 202) throw new Error('Signup failed'); });
  }

  function bindForms(root) {
    (root || document).querySelectorAll('form[data-nb-klaviyo]').forEach(function (form) {
      if (form.dataset.nbBound) return;
      form.dataset.nbBound = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[type="email"]');
        var msg = form.querySelector('[data-nb-msg]');
        var btn = form.querySelector('button');
        if (!input || !input.value) return;
        btn && (btn.disabled = true);
        klaviyoSubscribe(form.dataset.company, form.dataset.list, input.value.trim())
          .then(function () {
            if (msg) { msg.textContent = form.dataset.success || "You're on the list!"; msg.hidden = false; }
            input.value = '';
          })
          .catch(function () {
            if (msg) { msg.textContent = 'Something went wrong. Please try again.'; msg.hidden = false; }
          })
          .finally(function () { btn && (btn.disabled = false); });
      });
    });
  }

  function bindBuybar() {
    var bar = document.querySelector('[data-nb-buybar]');
    var trigger = document.querySelector('[data-nb-hero-cta]');
    if (!bar || !trigger || !('IntersectionObserver' in window)) { bar && bar.classList.add('is-visible'); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }).observe(trigger);
  }

  function init(root) { bindForms(root); bindBuybar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
